"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSelectedShippingMethodAction = exports.SET_SELECTED_SHIPPING_METHOD = exports.updateShippingMethodsAction = exports.UPDATE_SHIPPING_METHODS = void 0;
var actions_1 = require("../../utils/actions");
var prefix = 'EJS_CHECKOUT_SHIPPING_METHODS';
exports.UPDATE_SHIPPING_METHODS = "".concat(prefix, "UPDATE_SHIPPING_METHODS");
exports.updateShippingMethodsAction = (0, actions_1.actionCreator)(exports.UPDATE_SHIPPING_METHODS);
exports.SET_SELECTED_SHIPPING_METHOD = "".concat(prefix, "SET_SELECTED_SHIPPING_METHOD");
exports.setSelectedShippingMethodAction = (0, actions_1.actionCreator)(exports.SET_SELECTED_SHIPPING_METHOD);
